<template>
  <el-row class="page" :gutter="24" style="padding-right: 24px;">
    <el-col :span="6">
      <el-card class="box-card">
        <div slot="header" class="clearfix header">
          <span>Статусы</span>
          <span class="subheader">Статусы фискализации, за 7 дней</span>
        </div>
        <el-table :data="ticketsReport" size="mini" v-loading="loading">
          <el-table-column prop="id_statuses" label="Статус" size="mini">
            <template slot-scope="scope">
              <span :style="'color: ' + statusColor(scope.row.id_statuses)">
                <i v-if="scope.row.id_statuses == 1" class="el-icon-loading"></i>
                <i v-if="scope.row.id_statuses == 2" class="el-icon-loading"></i>
                <i v-if="scope.row.id_statuses == 3" class="el-icon-check"></i>
                <i v-if="scope.row.id_statuses == 4" class="el-icon-close"></i>
                {{ humanStatus(scope.row.id_statuses) }}
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="count" label="Количество" width="95"></el-table-column>
        </el-table>
      </el-card>

      <el-card class="box-card" style="margin-top: 25px">
        <div slot="header" class="clearfix header">
          <span>Серии</span>
          <span class="subheader">Выданные серии билетов для огранизации</span>
        </div>
        <el-table :data="series" size="mini" v-loading="loading">
          <el-table-column
            prop="number"
            label="Серия"
            size="mini"
            :formatter="padFormatter"
            width="65"
          ></el-table-column>
          <el-table-column prop="price" label="Цена" :formatter="priceFormatter" width="65"></el-table-column>
          <el-table-column prop="payment_type" label="Расчет">
            <template slot-scope="scope">
              <el-tag :type="scope.row.payment_type == 'cash' ? 'success' : 'primary'">
                <i v-if="scope.row.payment_type == 'cash'" class="el-icon-money"></i>
                <i v-else class="el-icon-bank-card"></i>
                {{ humanPt(scope.row.payment_type) }}
              </el-tag>
            </template>
          </el-table-column>
        </el-table>
      </el-card>
    </el-col>
    <el-col :span="12">
      <el-card class="box-card">
        <div slot="header" class="clearfix header">
          <el-tooltip content="Добавить" placement="bottom" style="float: right">
            <el-button @click="dialog = true" type="primary" icon="el-icon-plus" circle></el-button>
          </el-tooltip>
          <span>Билеты</span>
          <span class="subheader">Билеты внесенные на фискализацию, за 7 дней</span>
        </div>
        <el-table :data="paginatedTickets" size="mini" stripe v-loading="loading">
          <el-table-column prop="id" width="30">
            <template slot-scope="scope">
              <a style="color: #409EFF" v-if="scope.row.id_statuses == 3" :href="scUrl(scope.row)">
                <i class="el-icon-share"></i>
              </a>
            </template>
          </el-table-column>
          <el-table-column prop="created_at" label="Дата" :formatter="dateFormatter"></el-table-column>
          <el-table-column
            prop="series_number"
            label="Серия"
            :formatter="padFormatter"
            width="70"
            :filters="filterSeries"
            :filter-method="filterSeriesHandler"
          ></el-table-column>
          <el-table-column prop="number" label="Номер" width="70" :formatter="padFormatter"></el-table-column>
          <el-table-column prop="price" label="Цена" width="80">
            <template slot-scope="scope">
              <el-tooltip :content="humanPt(scope.row.payment_type)">
                <i v-if="scope.row.payment_type == 'cash'" class="el-icon-money"></i>
                <i v-else class="el-icon-bank-card"></i>
              </el-tooltip>
              {{ scope.row.price }} ₽
            </template>
          </el-table-column>
          <el-table-column
            prop="id_statuses"
            label="Статус"
            :filters="filterStatus"
            :filter-method="filterStatusHandler"
          >
            <template slot-scope="scope">
              <el-tooltip :disabled="scope.row.id_statuses !== 4" :content="humanStatusTooltip(scope.row)">
                <span :style="'color: ' + statusColor(scope.row.id_statuses)">
                  <i v-if="scope.row.id_statuses == 1" class="el-icon-loading"></i>
                  <i v-if="scope.row.id_statuses == 2" class="el-icon-loading"></i>
                  <i v-if="scope.row.id_statuses == 3" class="el-icon-check"></i>
                  <i v-if="scope.row.id_statuses == 4" class="el-icon-close"></i>
                  {{ humanStatus(scope.row.id_statuses) }}
                </span>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>
        <div style="margin-top: 20px; text-align: center">
          <el-pagination
            background
            layout="prev, pager, next"
            :current-page.sync="ticketsPage"
            :page-size="ticketsPerPage"
            :total="tickets.length"
          ></el-pagination>
        </div>
      </el-card>
    </el-col>

    <el-dialog title="На фискализацию" :visible.sync="dialog" width="440px" :show-close="false">
      <el-form :model="form" label-width="140px">
        <el-form-item label="Серия">
          <el-select v-model="form.series" placeholder="серия" style="width: 200px;">
            <el-option v-for="s of series" :key="s.id" :label="pad(6, s.number, '0')" :value="s.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="form.series" :label="humanPt(findSeries(form.series)['payment_type'])"
          >{{ findSeries(form.series)["price"] }} ₽</el-form-item
        >
        <el-form-item label="Начальный билет">
          <el-input v-model="form.start" style="width: 200px;" @blur="checkLastNumber()"></el-input>
        </el-form-item>
        <el-form-item v-if="this.form.rolls">
          <el-checkbox v-model="form.is_ended">Катушка закончилась</el-checkbox>
        </el-form-item>
        <el-form-item v-if="!this.form.is_ended" label="Последний билет">
          <el-input v-model="form.stop" style="width: 200px;"></el-input>
        </el-form-item>
        <el-form-item label="ТС" v-if="dicts.transports.length">
          <el-select v-model="form.transports" placeholder="ТС" style="width: 200px;" clearable>
            <el-option v-for="s of dicts['transports']" :key="s.id" :label="s.number" :value="s.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="Маршрут" v-if="dicts.routes.length">
          <el-select v-model="form.routes" placeholder="ТС" style="width: 200px;" clearable>
            <el-option v-for="s of dicts['routes']" :key="s.id" :label="s.number" :value="s.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="Катушка" v-if="this.form.rolls">
          {{ pad(6, roll.begin_number, "0") }} - {{ pad(6, roll.end_number, "0") }}
        </el-form-item>
        <el-form-item v-if="this.form.start && this.form.stop" label="Выбрано билетов">
          {{ this.form.stop - this.form.start }} шт
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialog = false">Отмена</el-button>
        <el-button type="primary" @click="add" :disabled="!testForm">Добавить</el-button>
      </span>
    </el-dialog>
  </el-row>
</template>

<script>
// @ is an alias to /src
import moment from "moment-timezone";
import pad from "pad";
import jwtDecode from "jwt-decode";
import { Notification } from "element-ui";
import { mapState } from "vuex";

moment.locale("ru");

export default {
  name: "Home",
  components: {},
  data: () => ({
    pad,
    timer: null,
    token: null,
    user: null,
    logged: false,
    dialog: false,
    series: [],
    tickets: [],
    ticketsPage: 1,
    ticketsPerPage: 20,
    statuses: [
      { id: 1, title: "В очереди" },
      { id: 2, title: "Фискализация" },
      { id: 3, title: "Завершено" },
      { id: 4, title: "Ошибка" },
    ],
    form: {
      series: "",
      start: "",
      stop: "",
      routes: "",
      transports: "",
      rolls: "",
      is_ended: false,
    },
    roll: null,
    loading: true,
  }),
  computed: {
    ...mapState(["dicts", "dictsNames"]),
    filterSeries() {
      return this.series.map((e) => ({
        text: pad(6, e.number, "0"),
        value: pad(6, e.number, "0"),
      }));
    },
    filterStatus() {
      return this.statuses.map((e) => {
        return {
          text: e.title,
          value: e.id,
        };
      });
    },
    paginatedTickets() {
      return this.tickets.slice((this.ticketsPage - 1) * this.ticketsPerPage, this.ticketsPage * this.ticketsPerPage);
    },
    ticketsReport() {
      return this.tickets
        .reduce((r, t) => {
          const cur = r.find((e) => e.id_statuses == t.id_statuses);
          if (!cur) {
            r.push({ id_statuses: t.id_statuses, count: 1 });
          } else {
            cur.count += 1;
          }
          return r;
        }, [])
        .sort((a, b) => a.id_statuses - b.id_statuses);
    },
    testUser() {
      if (this.user.id_user_types && this.user.id_user_types >= 4) return true;
      if (this.user.id_clients == 8) return true;
      return false;
    },
    testForm() {
      if (this.form.start && this.form.stop && this.form.series) {
        const count = this.form.stop - this.form.start;
        if (count > 0) return true;
      }
      return false;
    },
  },
  async created() {
    const token = window.localStorage.getItem("token");
    if (!token && this.$route.name != "Login") {
      this.$router.push({ name: "Login" });
      return;
    }

    this.token = token;
    this.user = jwtDecode(token);
    this.logged = !!token;

    try {
      const series = await this.$axios.get("/api/series");
      this.series = series.data.data.series.filter((e) => e.is_visible);
      if (this.series.length > 0) {
        this.form.series = this.series[0]["id"];
      }
      await this.updateTickets();

      this.timer = setInterval(this.updateTickets, 30000);
    } catch (e) {
      console.log(e);
    }

    const dictsPromises = [];
    for (const entity of Object.keys(this.dictsNames)) {
      dictsPromises.push(
        this.$axios
          .get(`/api/dicts/${entity}`)
          .then((result) => {
            return this.$store.dispatch("updateDict", {
              title: entity,
              dict: result.data.data,
            });
          })
          .catch((e) => console.log(e))
      );
    }
    await Promise.all(dictsPromises);
    this.loading = false;
  },
  methods: {
    async qrTlg() {
      const qrRes = await this.$axios.get(`/api/auth/telegram`);
      this.$alert(
        `<img src="data:image/jpeg;base64,${qrRes.data.data.qr}" />Отсканируйте код на мобильном<br/>устройстве и перейдите по ссылке`,
        "",
        {
          dangerouslyUseHTMLString: true,
          center: true,
        }
      );
    },
    filterCahnge(filters) {
      console.log(JSON.stringify(filters));
    },
    scUrl(ticket) {
      return `https://scurl.ru/${pad(6, ticket.series_number, "0")}/${pad(6, ticket.number, "0")}`;
    },
    dateFormatter(row, column, cellValue) {
      return moment(cellValue).format("D MMM HH:mm");
    },
    padFormatter(row, column, cellValue) {
      return pad(6, cellValue, "0");
    },
    ptFormatter(row, column, cellValue) {
      return this.humanPt(cellValue);
    },
    statusFormatter(row, column, cellValue) {
      return this.humanStatus(cellValue);
    },
    priceFormatter(row, column, cellValue) {
      return `${parseFloat(cellValue).toFixed(2)} ₽`;
    },
    statusColor(status) {
      if (status == 3) return "#67C23A";
      if (status == 4) return "#F56C6C";
      return "#606266";
    },
    async updateTickets() {
      const result = await this.$axios.get("/api/tickets");
      if (result.status == 200) {
        result.data.data.tickets.map((t) => {
          t.request_data = JSON.parse(t.request_data);
          return t;
        });
        this.tickets = result.data.data.tickets;
      }
    },
    findSeries(id) {
      return this.series.find((e) => e.id == id);
    },
    humanPt: (type) => (type == "cash" ? "Наличный" : "Безналичный"),
    humanStatus(status) {
      return this.statuses.find((e) => e.id == status)["title"];
    },
    humanStatusTooltip(ticket) {
      if (ticket.id_statuses == 4 && ticket.request_data && ticket.request_data.error) {
        return ticket.request_data.error.text;
      }
      if (ticket.id_statuses == 4 && ticket.ofd_data && ticket.ofd_data.error) {
        return ticket.request_data.error.text;
      }
      return this.humanStatus(ticket.id_statuses);
    },

    filterSeriesHandler(value, row) {
      return row.series_number == value;
    },
    filterStatusHandler(value, row) {
      return row.id_statuses == value;
    },
    async add() {
      this.dialog = false;
      console.log("add");

      try {
        const data = Object.assign({}, this.form);
        data.stop--;
        const result = await this.$axios.post("/api/tickets", data);

        if (result.status == 200) {
          Notification.success({
            title: "Успешно",
            message: "Билеты были добавлены",
          });
          await this.updateTickets();
          await this.$axios
            .get(`/api/dicts/rolls`)
            .then((result) => {
              return this.$store.dispatch("updateDict", {
                title: "rolls",
                dict: result.data.data,
              });
            })
            .catch((e) => console.log(e));

          this.form.routes = "";
          this.form.transports = "";
          this.form.rolls = "";
          this.form.start = "";
          this.form.stop = "";
          this.roll = null;
        } else {
          Notification.error({ title: "Ошибка", message: result.data.message });
        }
      } catch (e) {
        Notification.error({ title: "Ошибка", message: "Ошбика связи" });
      }
    },
    inRoll(number) {
      if (this.dicts["rolls"] && this.dicts["rolls"].length) {
        const roll = this.dicts["rolls"].find(
          (e) => e.begin_number <= number && number <= e.end_number && e.id_series == this.form.series
        );
        if (roll) {
          return roll;
        }
      }
      return false;
    },
    checkLastNumber() {
      if (this.roll && this.roll.last_number && this.form.start) {
        if (this.form.start < this.roll.last_number) {
          Notification.warning({
            title: "Внимание!",
            message: `Последний фискализированный на катушке номер ${this.roll.last_number} больше того, который указали вы ${this.form.start}. Вы уверены?`,
          });
        } else if (this.form.start != this.roll.last_number + 1) {
          Notification.warning({
            title: "Внимание!",
            message: `Последний фискализированный на катушке номер ${this.roll.last_number}, однако вы указали следующим на фискализацию билет ${this.form.start}. Это проведет к образованию "дыры" в катушке. Вы уверены?`,
          });
        }
      }
    },
  },
  watch: {
    "form.start": function(number) {
      number = parseInt(number);
      const roll = this.inRoll(number);

      if (roll) {
        this.form.routes = roll.id_routes;
        this.form.transports = roll.id_transports;
        this.form.rolls = roll.id;
        this.roll = roll;
      } else {
        this.form.routes = "";
        this.form.transports = "";
        this.form.rolls = "";
        this.roll = null;
      }
    },
    "form.stop": function(number) {
      if (this.form.rolls) return;

      number = parseInt(number);
      const roll = this.inRoll(number);

      if (roll) {
        this.form.routes = roll.id_routes;
        this.form.transports = roll.id_transports;
        if (!this.form.start) this.form.start = pad(6, roll.last_number + 1, "0");
        this.form.rolls = roll.id;
        this.roll = roll;
      } else {
        this.form.routes = "";
        this.form.transports = "";
        this.form.rolls = "";
        this.roll = null;
      }
    },
    "form.is_ended": function(is_ended) {
      if (is_ended && this.roll) {
        if (!this.roll) return;
        this.form.stop = this.roll.end_number + 1;
      }
      if (!is_ended) {
        this.form.stop = "";
      }
    },
  },
};
</script>
